import React, { useState } from 'react';

import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { bgBlur } from 'src/theme/css';
import Logo from 'src/components/logo';
import { NavSectionHorizontal } from 'src/components/nav-section';
import { useResponsive } from 'src/hooks/use-responsive';
import Iconify from 'src/components/iconify';
import { useNavData } from './config-navigation';
import MobileMenu from './mobile-menu';
import ContextToolbar from './context-toolbar';

export default function Header() {
  const theme = useTheme();
  const lgUp = useResponsive('up', 'lg');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const navData = useNavData();

  return (
    <>
      <AppBar
        sx={{
          zIndex: theme.zIndex.appBar + 1,
          ...bgBlur({ color: theme.palette.background.default }),
        }}
      >
        <Toolbar>
          <IconButton
            onClick={handleMobileMenuToggle}
            sx={{ display: { xs: 'block', lg: 'none' } }}
          >
            <Iconify icon="eva:menu-2-fill" />
          </IconButton>
          <Logo />
          {lgUp && <NavSectionHorizontal data={navData} />}
          <ContextToolbar />
        </Toolbar>
      </AppBar>
      {!lgUp && <MobileMenu open={mobileMenuOpen} onClose={handleMobileMenuToggle} />}
    </>
  );
}
